import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const ViewPageBusiness = ({
  open,
  onClose,
  currentRequest,
  newRequest,
  status,
  currentId,
  handleAdminResponse,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: "20px" },
      }}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle className="request-head">Request Details</DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <Typography variant="h6">
            Status: <span className="status-span">{status}</span>
          </Typography>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className="request-subhead">Field</TableCell>
                <TableCell className="request-subhead">Old Value</TableCell>
                <TableCell className="request-subhead">Edited Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell className="subhead">Franchisee Name</TableCell>
                <TableCell>
                  {currentRequest?.businessName || <Typography>N/A</Typography>}
                </TableCell>
                <TableCell>
                  {newRequest?.businessName || <Typography>N/A</Typography>}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="subhead">Description</TableCell>
                <TableCell>
                  {currentRequest?.description || <Typography>N/A</Typography>}
                </TableCell>
                <TableCell>
                  {newRequest?.description || <Typography>N/A</Typography>}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="subhead">Mobile Number</TableCell>
                <TableCell>
                  {currentRequest?.mobileNumber || <Typography>N/A</Typography>}
                </TableCell>
                <TableCell>
                  {newRequest?.mobileNumber || <Typography>N/A</Typography>}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="subhead">Place</TableCell>
                <TableCell>
                  {currentRequest?.place || <Typography>N/A</Typography>}
                </TableCell>
                <TableCell>
                  {newRequest?.place || <Typography>N/A</Typography>}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          color="error"
          style={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        {status === "Pending" && (
            <>
        <Button
          variant="outlined"
          color="success"
          style={{ marginRight: "5px" }}
          onClick={() => {
            handleAdminResponse(currentId, "accept");
            onClose();
          }}
        >
          Accept
        </Button>
        <Button
          variant="outlined"
          color="error"
          style={{ marginRight: "5px" }}
          onClick={() => {
            handleAdminResponse(currentId, "reject");
            onClose();
          }}
        >
          Reject
        </Button>
        </>)}
      </DialogActions>
    </Dialog>
  );
};

export default ViewPageBusiness;
